import BlogAuthor from './BlogAuthor';

export default BlogAuthor;
